// extracted by mini-css-extract-plugin
export default {"addToCartControl":"O1-z","giftCard":"P1-z","btnContainer":"Q1-z","cartButton":"R1-z","disabled":"S1-z"};